import { Button } from '../ui/button';
import styles from './styles.module.scss';
import { toast as sonnerToast } from 'sonner';
import { clsx } from 'clsx';
import { X } from 'lucide-react';

type ToastProps = {
	id: string | number;
	mode: 'default' | 'informative' | 'destructive' | 'caution';
	title?: string;
	description: string;
	action?: {
		label: string;
		onClick: () => void;
	};
};

export const Toast = (props: ToastProps) => {
	// dissmiss with sonnerToast.dismiss(props.id)
	return (
		<div className={clsx(styles.toast, styles[props.mode])}>
			<div className={styles.text}>
				{props.title && <p className={styles.title}>{props.title}</p>}
				<p className={styles.description}>{props.description}</p>
			</div>
			<div className={styles.buttons}>
				{props.action && (
					<Button
						variant={
							props.mode === 'destructive'
								? 'destructive'
								: 'default'
						}
						size={'sm'}
						onClick={props.action.onClick}
						className={styles.button}
					>
						{props.action.label}
					</Button>
				)}
				<Button
					size={'icon'}
					onClick={() => sonnerToast.dismiss(props.id)}
					variant={'ghost'}
				>
					<X />
				</Button>
			</div>
		</div>
	);
};

export const toast = (props: Omit<ToastProps, 'id'>) =>
	sonnerToast.custom((id) => <Toast id={id} {...props} />, {
		position: 'bottom-right',
		duration: Infinity,
	});
